import {Action, Module, Mutation} from 'vuex-module-decorators';
import store from '@/store';
import {take} from 'rxjs/operators';
import {EntityStateAdapter} from '@/store/base.store';
import {CertificateModel} from '@/models/certificate.model';
import {CertificateApi} from '@/api/certificate.api';
import {TimelineModel} from '@/models/timeline.model';

export const featureKey = 'certificates';

// @ts-ignore
if (store.state.certificates) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class CertificateStoreModule extends EntityStateAdapter<CertificateModel> {

  private _certificate: CertificateModel | null = null;

  get certificates(): CertificateModel[] {
    return this._entities;
  }

  get certificate(): CertificateModel | null {
    return this._certificate;
  }

  @Mutation
  getCertificate(certificate: CertificateModel | null) {
    this._certificate = certificate;
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchAll(): Promise<CertificateModel[]> {
    return await (new CertificateApi())
      .all()
      .pipe(take(1))
      .toPromise()
  }

  @Action({commit: 'getCertificate', rawError: true})
  async findByVerifyCode(code: string): Promise<CertificateModel> {
    return await (new CertificateApi())
      .findByVerifyCode(code)
      .pipe(take(1))
      .toPromise()
  }
}
